import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {Flyout} from '../../../atoms/Flyout/Flyout';

interface SortFlyoutProps {
  title: string;
  onClose: () => void;
  open: boolean;
  renderInPortal?: boolean;
}

export const SortFlyout: React.FC<React.PropsWithChildren<SortFlyoutProps>> = ({
  title,
  onClose,
  open,
  renderInPortal,
  children,
}) => {
  return (
    <Flyout
      headerContent={
        <HeaderTitle data-testid="sortFlyoutHeaderTitle">{title}</HeaderTitle>
      }
      onClose={onClose}
      open={open}
      renderInPortal={renderInPortal}
      bodyContent={children}
    />
  );
};

const HeaderTitle = styled.h3`
  display: block;
  width: 100%;
  font-weight: ${FONT_WEIGHTS.w500};
  font-size: ${FONT_SIZES.px20};
  color: ${COLORS.Black};
  text-align: left;
  margin: 0;
  padding: 0 1rem;
  box-sizing: border-box;
`;
